import React, { useState } from 'react'
import { Mail, ArrowRight, CheckCircle } from 'lucide-react'

const SignUp: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [isSuccess, setIsSuccess] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!email) return

    setIsLoading(true)
    try {
      const { subscribeEmail } = await import('../utils/api')
      const result = await subscribeEmail(email)
      setMessage(result.message)
      setIsSuccess(result.success)
      
      if (result.success) {
        setEmail('')
      }
    } catch (error) {
      setMessage('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.')
      setIsSuccess(false)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <section className="py-20 bg-gradient-to-br from-primary-600 to-blue-700 text-white">
      <div className="container-width section-padding">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-yellow-300">5초면</span> 충분합니다
          </h2>
          
          <p className="text-xl mb-12 text-blue-100 leading-relaxed">
            이메일만 입력하면 바로 시작할 수 있습니다
            <br />
            복잡한 가입 절차나 개인정보는 필요하지 않습니다
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-8 md:p-12 rounded-3xl border border-white/20 mb-12">
            <form onSubmit={handleSubmit} className="max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-4 mb-6">
                <div className="flex-1">
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="이메일을 입력하세요"
                    className="w-full px-6 py-4 text-lg rounded-xl border-2 border-white/20 bg-white/10 text-white placeholder-white/60 focus:border-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-300/50 transition-all duration-200"
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={isLoading}
                  className="bg-yellow-500 hover:bg-yellow-400 text-gray-900 font-bold px-8 py-4 text-lg rounded-xl transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-yellow-300 flex items-center justify-center gap-2 min-w-[160px]"
                >
                  {isLoading ? (
                    <div className="w-6 h-6 border-2 border-gray-900/30 border-t-gray-900 rounded-full animate-spin"></div>
                  ) : (
                    <>
                      무료 구독하기
                      <ArrowRight className="w-5 h-5" />
                    </>
                  )}
                </button>
              </div>
              
              {message && (
                <div className={`p-4 rounded-xl ${isSuccess ? 'bg-green-500/20 border border-green-400/30' : 'bg-red-500/20 border border-red-400/30'} mb-6`}>
                  <div className="flex items-center gap-2">
                    {isSuccess && <CheckCircle className="w-5 h-5 text-green-400" />}
                    <p className={`text-sm ${isSuccess ? 'text-green-100' : 'text-red-100'}`}>
                      {message}
                    </p>
                  </div>
                </div>
              )}
              
              <div className="flex items-center justify-center gap-2 text-blue-200 text-sm">
                <Mail className="w-4 h-4" />
                <span>무료 구독 • 언제든 취소 가능 • 스팸 없음</span>
              </div>
            </form>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
            <div className="bg-white/10 p-6 rounded-2xl border border-white/20">
              <div className="text-2xl font-bold text-yellow-300 mb-2">1단계</div>
              <p className="text-blue-100">이메일 입력</p>
            </div>
            <div className="bg-white/10 p-6 rounded-2xl border border-white/20">
              <div className="text-2xl font-bold text-yellow-300 mb-2">2단계</div>
              <p className="text-blue-100">구독 완료</p>
            </div>
            <div className="bg-white/10 p-6 rounded-2xl border border-white/20">
              <div className="text-2xl font-bold text-yellow-300 mb-2">3단계</div>
              <p className="text-blue-100">첫 뉴스레터 수신</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SignUp
